import { API_URL } from '../utils/apiConfig';

// Helper function to get token from localStorage
const getToken = () => {
  const storedUser = localStorage.getItem('user');
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      return user.token;
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
    }
  }
  return null;
};

// Helper function to handle logout on token expiry
const handleAuthFailure = () => {
  // Clear localStorage
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  
  // Redirect to login
  window.location.href = '/login';
};

export const fetchWithAuth = async (endpoint, options = {}) => {
  const token = getToken();
  
  if (!token) {
    throw new Error('User not authenticated');
  }
  
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    ...options.headers,
  };
  
  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });
  
  if (!response.ok) {
    // Handle 401 Unauthorized - token expired or invalid
    if (response.status === 401) {
      // Logout user and redirect
      handleAuthFailure();
      throw new Error('Session expired. Please login again.');
    }

    let errorBody = null;
    try {
      errorBody = await response.json();
    } catch (_) {
      // Non-JSON error
    }

    const serverMessage =
      (errorBody && (errorBody.message || errorBody.error)) ||
      response.statusText ||
      'Something went wrong';

    throw new Error(serverMessage);
  }
  
  return response.json();
};